import { Box, Typography } from '@mui/material';
import { ContentWrapper } from '@/components/ContentWrapper';
import {
    FONT_WEIGHT,
    Heading,
    LINE_HEIGHT,
    PageSubHeading,
    TEXT_SIZE
} from '@/typography/Typography';
import { SicknessReport } from '@/components/reports/SicknessReport';
import { SicknessDashboard } from '@/components/reports/SicknessDashboard';
import { SickWithPayReport } from '@/components/reports/SickWithPayReport';
import { EmployeeChurnReport } from '@/components/reports/EmployeeChurnReport';
import { OvertimeReport } from '@/components/reports/OvertimeReport';
import { HoursWorkedReport } from '@/components/reports/HoursWorkedReport';
import { ViewSwitch } from '@/components/shared/ViewSwitch';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUser } from '@/contexts/user/UserContext';
import { UserRoles } from '@/models/company';

export const ReportsDashboard = () => {
    const { t } = useTranslation();
    const { user } = useUser();

    const isSuperAdmin = user?.role === UserRoles.SuperAdmin;

    const viewSwitchItems = [
        {
            primaryText: t('dashboard'),
            route: 'dashboard',
            badgeText: '',
            routeComponent: <SicknessDashboard />
        },
        {
            primaryText: t('sickness_report'),
            route: 'sickness_report',
            badgeText: '',
            routeComponent: <SicknessReport />
        },
        ...(isSuperAdmin
            ? [
                  {
                      primaryText: 'Sick with pay',
                      route: 'sick_with_pay',
                      badgeText: '',
                      routeComponent: <SickWithPayReport />
                  },
                  {
                      primaryText: 'Employee churn',
                      route: 'employee_churn',
                      badgeText: '',
                      routeComponent: <EmployeeChurnReport />
                  },
                  {
                      primaryText: 'Overtime',
                      route: 'overtime',
                      badgeText: '',
                      routeComponent: <OvertimeReport />
                  },
                  {
                      primaryText: 'Hours worked',
                      route: 'hours_worked',
                      badgeText: '',
                      routeComponent: <HoursWorkedReport />
                  }
              ]
            : [])
    ];
    const [tabIndex, setTabIndex] = useState<number | null>(null);

    return (
        <ContentWrapper>
            <>
                <Box m={1} display={'flex'} justifyContent={'space-between'}>
                    <Typography variant="h4" marginBottom="5px">
                        <Heading
                            fontSize={TEXT_SIZE.MEDIUM_LARGE}
                            fontWeight={FONT_WEIGHT.MEDIUM}
                            lineHeight={LINE_HEIGHT.XLARGE}
                        >
                            Reports
                        </Heading>
                        <PageSubHeading>
                            Access your reports here.
                        </PageSubHeading>
                    </Typography>
                </Box>
                {/* <ChartPOC /> */}

                {/* <ChartPOC /> */}

                <ViewSwitch
                    itemList={viewSwitchItems}
                    setSelectedIndex={setTabIndex}
                    selectedIndex={tabIndex}
                />
            </>
        </ContentWrapper>
    );
};
